import { render, staticRenderFns } from "./BlogMainWrapperRight.vue?vue&type=template&id=c57bbd46&"
import script from "./BlogMainWrapperRight.vue?vue&type=script&lang=js&"
export * from "./BlogMainWrapperRight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports